import "@polymer/polymer/polymer-legacy.js";
const _documentContainer = document.createElement("template");
_documentContainer.innerHTML = `<dom-module id="nav-styles">
  <template>
    <style>
      :host {
        --app-primary-color: #4285f4;
        --app-secondary-color: black;

        display: block;
      }

      app-header {
        color: #fff;
        background-color: var(--app-primary-color);
      }
      
      app-header paper-icon-button {
        --paper-icon-button-ink-color: white;
      }

      .drawer-list a {
        display: block;
        padding: 0 16px;
        text-decoration: none;
        color: var(--app-secondary-color);
        line-height: 40px;
      }

      .drawer-list a.iron-selected {
        color: black;
        font-weight: bold;
      }

      /* Hamburger menu button for navigation */
      #menu-button {
        left: 250px;
        position: absolute;
        color: #2E2E2E;
        visibility: visible;
      }

      app-drawer {
        --app-drawer-content-container: {
          background-color: #B0BEC5;
          padding-left: 0px;
          padding-right: 0px;
          padding-bottom: 0px;
          height: 100%;
        };
        /*--app-drawer-scrim-background: rgba(0, 0, 0, 0);*/
        --app-drawer-scrim-background: rgba(0, 0, 100, 0.8);
      }

      iron-pages {
        height: 100vh;
      }

      p {
        font-size: 10px;
        margin: 0px;
        padding-left: 155px;
      }
      /*paper-button {*/
        /*--paper-button: {*/
          /*@apply(--layout-vertical);*/
          /*@apply(--layout-center-center);*/
        /*};*/
      /*}*/
      /*paper-button.custom:hover {*/
        /*background-color: #6DA2DE;*/
      /*}*/
      /*paper-icon-item {*/
        /*padding: 0px;*/
        /*--paper-item-min-height: 25px;*/
      /*}*/
      /*paper-button {*/
        /*background-color: #549FB8;*/
        /*font-family: 'Roboto', 'Noto', sans-serif;*/
        /*font-weight: normal;*/
        /*font-size: 14px;*/
        /*-webkit-font-smoothing: antialiased;*/
        /*display: block;*/
        /*margin-top: 10px;*/
        /*text-align: center;*/
      /*}*/
      /*paper-button.custom:hover {*/
        /*background-color: #6DA2DE;*/
      /*}*/

      .nav-logo {
        left: 30px;
        position: relative;
        top: 10px;
      }

      #nav-logo {
        max-height: 44px;
        margin-right: 10px;
        margin-top: 5px;
      }

      .logout {
        background-color: #93C2D0;
        border: 1px solid #4b98b4;
      }


    </style>
  </template>
</dom-module>`;
document.head.appendChild(_documentContainer.content);
//# sourceMappingURL=nav-styles.js.map